/*!

=========================================================
* Black Dashboard React v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import * as ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

// Layouts
// import RTLLayout from "layouts/RTL/RTL.js";
// import AdminLayout from "layouts/Admin/Admin.js";
import AdminLayoutContainer from './container/MainLayout/AdminLayoutContainer';
import LogInContainer from './container/MainLayout/LogInContainer';
import PartnerPortalEntry from './views/MainLayout/PartnerPortalEntry';
// import DefaultLayoutContainer from './container/MainLayout/DefaultLayoutContainer'

// Wrappers
import ThemeContextWrapper from "./components/ThemeWrapper/ThemeWrapper";
import BackgroundColorWrapper from "./components/BackgroundColorWrapper/BackgroundColorWrapper";
import { PlatformProvider } from "./contexts/PlatformContext";

// Reducer
import dataReducer from './reducer/dataReducer';

// Configure axios with JWT interceptors (must be imported early)
import './constant/axiosConfig';

// Styles
import "assets/scss/black-dashboard-react.scss";
import "assets/demo/demo.css";
import "assets/css/nucleo-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

// Apply patches first
import applyTransitionGroupFix from './fixes/TransitionGroupFix';
applyTransitionGroupFix();

let store = createStore(dataReducer, composeWithDevTools(applyMiddleware(thunk, logger)));

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

// Get the root element
const container = document.getElementById("root");

// Use createRoot, but we'll patch react-transition-group
const root = ReactDOM.createRoot(container);

// Patch react-transition-group
// This makes findDOMNode work with React 18
if (!window.patchedReactTransitionGroup) {
  const originalCreateElement = React.createElement;
  
  // Override React.createElement to inject nodeRef
  React.createElement = function() {
    const args = Array.from(arguments);
    const type = args[0];
    const props = args[1] || {};
    
    // If we're creating a Transition component from react-transition-group
    if (type && 
        (type.name === 'Transition' || 
         type.displayName === 'Transition' || 
         (typeof type === 'string' && type.toLowerCase() === 'transition'))) {
      
      // Add a nodeRef if it doesn't have one
      if (!props.nodeRef) {
        // Create a ref
        const nodeRef = React.createRef();
        props.nodeRef = nodeRef;
        args[1] = props;
      }
    }
    
    return originalCreateElement.apply(this, args);
  };
  
  window.patchedReactTransitionGroup = true;
}

root.render(
  <Provider store={store}>
    <ThemeContextWrapper>
      <BackgroundColorWrapper>
        <PlatformProvider>
          <BrowserRouter>
            <React.Suspense fallback={loading()}>
              <Routes>
                <Route exact path="/login" element={<LogInContainer/>} />
                <Route exact path="/admin/*" element={<AdminLayoutContainer/>} />
                {/* 給同事的「合作夥伴專區」分享連結（v2.61.0）：登入後臺 → 自動跳去 partner 專區 */}
                <Route exact path="/partner" element={<PartnerPortalEntry/>} />
                {/* <Route path="/admin/*" element={<AdminLayout />} /> */}
                {/* <Route path="/rtl/*" element={<RTLLayout />} /> */}
                <Route
                  path="*"
                  element={<Navigate to="/admin" replace />}   /* /admin 會導向 firstAccessibleRoute（權限感知），不要寫死頁面 */
                />
              </Routes>
            </React.Suspense>
          </BrowserRouter>
        </PlatformProvider>
      </BackgroundColorWrapper>
    </ThemeContextWrapper>
  </Provider>
);